import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { Trash2, Plus, Minus, ArrowRight, ShoppingCart } from 'lucide-react';

const Cart = () => {
  const { cartItems, updateQuantity, removeFromCart, cartTotal } = useCart();
  const navigate = useNavigate();

  if (cartItems.length === 0) {
    return (
      <div className="white-card animate-slide-up" style={{ textAlign: 'center', padding: '4rem 2rem', maxWidth: '600px', margin: '4rem auto' }}>
        <ShoppingCart size={64} color="var(--text-muted)" style={{ margin: '0 auto 1.5rem', opacity: 0.5 }} />
        <h1>Your Cart is Empty</h1>
        <p style={{ color: 'var(--text-muted)', marginBottom: '2rem' }}>Looks like you haven't added any premium gear yet.</p>
        <Link to="/" className="btn btn-primary">
          Browse Products
        </Link>
      </div>
    );
  }

  return (
    <div className="animate-slide-up" style={{ maxWidth: '1000px', margin: '0 auto' }}>
      <h1 className="hero-heading" style={{ marginBottom: '2rem', fontWeight: '700' }}>Cart</h1>

      <div className="cart-grid">

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          {cartItems.map((item, index) => (
            <div key={item.id} className="glass-card cart-item-row" style={{ animationDelay: `${index * 0.1}s`, display: 'flex', alignItems: 'center', gap: '1.5rem', padding: '1.5rem' }}>
              <img src={item.image} alt={item.name} style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '12px' }} />

              <div style={{ flex: 1, minWidth: '150px' }}>
                <h3 className="heading-14" style={{ marginBottom: '0.25rem' }}>{item.name}</h3>
                <p className="text-12" style={{ marginBottom: '0.5rem' }}>{item.category}</p>
                <div className="heading-14">
                  ₹{item.price.toFixed(2)}
                </div>
              </div>

              <div className="cart-item-actions" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <div className="white-card" style={{ display: 'flex', alignItems: 'center', padding: '0.25rem 0.5rem', borderRadius: '30px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                  <button onClick={() => updateQuantity(item.id, -1)} className="btn-icon" style={{ width: '28px', height: '28px', background: 'transparent', color: 'var(--text-main)' }}>
                    <Minus size={14} />
                  </button>
                  <span className="heading-14" style={{ margin: '0 0.75rem' }}>{item.quantity}</span>
                  <button onClick={() => updateQuantity(item.id, 1)} className="btn-icon" style={{ width: '28px', height: '28px', background: 'transparent', color: 'var(--text-main)' }}>
                    <Plus size={14} />
                  </button>
                </div>

                <button
                  onClick={() => removeFromCart(item.id)}
                  className="btn-icon"
                  style={{ background: 'rgba(239, 68, 68, 0.08)', color: 'var(--danger)' }}
                >
                  <Trash2 size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="white-card" style={{ padding: '2rem', position: 'sticky', top: '100px', border: 'none' }}>
          <h3 className="heading-14" style={{ marginBottom: '1.5rem', fontSize: '16px !important' }}>Order Summary</h3>

          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }} className="text-12">
            <span>Subtotal</span>
            <span style={{ color: 'var(--text-main)', fontWeight: '600' }}>₹{cartTotal.toFixed(2)}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1.5rem' }} className="text-12">
            <span>Shipping</span>
            <span style={{ color: 'var(--success)', fontWeight: '600' }}>Free</span>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2rem', paddingTop: '1.5rem', borderTop: '1px solid var(--border-color)', alignItems: 'center' }}>
            <span className="heading-14" style={{ fontSize: '16px !important' }}>Total</span>
            <span className="heading-14" style={{ fontSize: '18px !important' }}>₹{cartTotal.toFixed(2)}</span>
          </div>

          <button
            className="btn btn-primary"
            style={{ width: '100%', justifyContent: 'center' }}
            onClick={() => navigate('/confirmation')}
          >
            Buy Now <ArrowRight size={14} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Cart;
